import { render, staticRenderFns } from "./modifly.vue?vue&type=template&id=996ca7fc&scoped=true"
import script from "./modifly.vue?vue&type=script&lang=js"
export * from "./modifly.vue?vue&type=script&lang=js"
import style0 from "./modifly.vue?vue&type=style&index=0&id=996ca7fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996ca7fc",
  null
  
)

export default component.exports